import { loadScript, loadStyle } from './mapUtils';

const resources = {
    d3CelestialCdn: `${process.env.VUE_APP_D3_CELESTIAL_BASE_URL}/${process.env.VUE_APP_D3_CELESTIAL_CDN_PATH}`,
    d3CelestialCss: `${process.env.VUE_APP_D3_CELESTIAL_BASE_URL}/${process.env.VUE_APP_D3_CELESTIAL_CSS_PATH}`,
    d3Cdn: `${process.env.VUE_APP_D3_CELESTIAL_BASE_URL}/${process.env.VUE_APP_D3_CDN_PATH}`,
    d3GeoProjectionCdn: `${process.env.VUE_APP_D3_CELESTIAL_BASE_URL}/${process.env.VUE_APP_D3_GEO_PROJECTION_CDN_PATH}`,
    dataUrl: `${process.env.VUE_APP_D3_CELESTIAL_BASE_URL}/data`
};

export const STAR_MAP_STYLES = [
    {
        label: 'Dark',
        background: '#000000',
        backgroundOpacity: 1,
        elements: '#FFFFFF'
    },
    {
        label: 'Copper',
        background: '#B17859',
        backgroundOpacity: 1,
        elements: '#EFD7CB'
    },
    {
        label: 'Light',
        background: '#FFFFFF',
        backgroundOpacity: 1,
        elements: '#000000'
    },
    {
        label: 'Beach',
        background: '#A9DCE3',
        backgroundOpacity: 1,
        elements: '#7689DE'
    },
    {
        label: 'Midnight',
        background: '#020C4C',
        backgroundOpacity: 1,
        elements: '#FFFFFF'
    },
    {
        label: 'Garden',
        background: '#008970',
        backgroundOpacity: 1,
        elements: '#99EEDF'
    },
    {
        label: 'Golden Night',
        background: '#242833',
        backgroundOpacity: 1,
        elements: '#E0C05F'
    },
    {
        label: 'Desert',
        background: '#EFC8B1',
        backgroundOpacity: 1,
        elements: '#8A6626'
    },
    {
        label: 'Jewel',
        background: '#3C7A72',
        backgroundOpacity: 1,
        elements: '#E3B0B3'
    },
    {
        label: 'Forest',
        background: '#0F4D19',
        backgroundOpacity: 1,
        elements: '#6FC27C'
    },
    {
        label: 'Sunflower',
        background: '#D5AD3A',
        backgroundOpacity: 1,
        elements: '#FFFFFF'
    },
    {
        label: 'Transparent light',
        background: '#FFFFFF',
        backgroundOpacity: 0,
        elements: '#FFFFFF'
    },
    {
        label: 'Vintage',
        background: '#F7FAE7',
        backgroundOpacity: 1,
        elements: '#C53623'
    },
    {
        label: 'Transparent dark',
        background: '#FFFFFF',
        backgroundOpacity: 0,
        elements: '#000000'
    },
    {
        label: 'Romantic',
        background: '#DFB7B5',
        backgroundOpacity: 1,
        elements: '#A62C17'
    }
];

const celestialConfig = {
    width: 1000,
    projection: 'stereographic', // Map projection used: airy, aitoff, armadillo, august, azimuthalEqualArea, azimuthalEquidistant, baker, berghaus, boggs, bonne, bromley, collignon, craig, craster, cylindricalEqualArea, cylindricalStereographic, eckert1, eckert2, eckert3, eckert4, eckert5, eckert6, eisenlohr, equirectangular, fahey, foucaut, ginzburg4, ginzburg5, ginzburg6, ginzburg8, ginzburg9, gringorten, hammer, hatano, healpix, hill, homolosine, kavrayskiy7, lagrange, larrivee, laskowski, loximuthal, mercator, miller, mollweide, mtFlatPolarParabolic, mtFlatPolarQuartic, mtFlatPolarSinusoidal, naturalEarth, nellHammer, orthographic, patterson, polyconic, rectangularPolyconic, robinson, sinusoidal, stereographic, times, twoPointEquidistant, vanDerGrinten, vanDerGrinten2, vanDerGrinten3, vanDerGrinten4, wagner4, wagner6, wagner7, wiechel, winkel3
    transform: 'equatorial', // Coordinate transformation: equatorial (default), ecliptic, galactic, supergalactic
    controls: false, // zoom controls
    orientationfixed: true,
    follow: 'zenith',
    disableAnimations: true,
    geopos: [0, 0],
    datapath: `${resources.dataUrl}/`,
    formFields: {
        location: true, // Set visiblity for each group of fields with the respective id
        general: true,
        stars: true,
        dsos: false,
        constellations: true,
        lines: true,
        other: true,
        download: true
    },
    stars: {
        show: true, // Show stars
        limit: 6, // Show only stars brighter than limit magnitude
        colors: false, // Show stars in spectral colors, if not use default color
        style: { fill: '#ffffff', opacity: 1 }, // Default style for stars
        designation: false, // Show star names (Bayer, Flamsteed, Variable star, Gliese or designation,
        // i.e. whichever of the previous applies first); may vary with culture setting
        designationType: 'desig', // Which kind of name is displayed as designation (fieldname in starnames.json)
        designationStyle: {
            fill: '#ffffff',
            font: "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
            align: 'left',
            baseline: 'top'
        },
        designationLimit: 2.5, // Show only names for stars brighter than nameLimit
        propername: false, // Show proper name (if present)
        propernameType: 'name', // Languge for proper name, default IAU name; may vary with culture setting
        // (see list below of languages codes available for stars)
        propernameStyle: { fill: '#ffffff' },
        propernameLimit: 1.5, // Show proper names for stars brighter than propernameLimit
        size: 7, // Maximum size (radius) of star circle in pixels
        exponent: -0.28, // Scale exponent for star size, larger = more linear
        data: 'stars.6.json' // Data source for stellar data,
        // number indicates limit magnitude
    },
    dsos: {
        show: false
    },
    constellations: {
        show: false,
        names: false, // Show constellation names
        namesType: 'iau', // Type of name Latin (iau, default), 3 letter designation (desig) or other language (see list below)
        nameStyle: {
            fill: '#ffffff',
            align: 'center',
            baseline: 'middle',
            font: [
                '14px Helvetica, Arial, sans-serif', // Style for constellations
                '12px Helvetica, Arial, sans-serif', // Different fonts for diff.
                '11px Helvetica, Arial, sans-serif'
            ]
        }, // ranked constellations
        lines: true, // Show constellation lines, style below
        lineStyle: { stroke: '#ffffff', width: 1, opacity: 0.6 },
        bounds: false, // Show constellation boundaries, style below
        boundStyle: { stroke: '#ffffff', width: 0.5, opacity: 0.8, dash: [2, 4] }
    },
    mw: {
        show: true, // Show Milky Way as filled multi-polygon outlines
        style: { fill: '#ffffff', opacity: 0.15 } // Style for MW layers
    },
    lines: {
        // Display & styles for graticule & some planes
        graticule: {
            show: false,
            stroke: '#ffffff',
            width: 0.6,
            opacity: 0.8,
            // grid values: "outline", "center", or [lat,...] specific position
            lon: { pos: [''], fill: '#ffffff', font: '10px Helvetica, Arial, sans-serif' },
            // grid values: "outline", "center", or [lon,...] specific position
            lat: { pos: [''], fill: '#ffffff', font: '10px Helvetica, Arial, sans-serif' }
        },
        ecliptic: { show: false, stroke: '#ffffff', width: 1.3, opacity: 0.7 },
        equatorial: { show: false }
        // galactic: { show: false, stroke: "#cc6666", width: 1.3, opacity: 0.7 },
        // supergalactic: { show: false, stroke: "#cc66cc", width: 1.3, opacity: 0.7 }
    },
    planets: {
        show: false,
        which: ['sol', 'mer', 'ven', 'ter', 'lun', 'mar', 'jup', 'sat', 'ura', 'nep'],
        // Font styles for planetary symbols
        symbolType: 'disk',
        symbols: {
            // Character and color for each symbol in 'which', simple circle \u25cf
            sol: { symbol: '\u2609', letter: 'Su', fill: '#ffff00', size: '24' },
            mer: { symbol: '\u263f', letter: 'Me', fill: '#cccccc' },
            ven: { symbol: '\u2640', letter: 'V', fill: '#eeeecc' },
            ter: { symbol: '\u2295', letter: 'T', fill: '#00ccff' },
            lun: { symbol: '\u25cf', letter: 'L', fill: '#ffffff', size: '24' }, // overridden by generated crecent, except letter & size
            mar: { symbol: '\u2642', letter: 'Ma', fill: '#ff6600' },
            cer: { symbol: '\u26b3', letter: 'C', fill: '#cccccc' },
            ves: { symbol: '\u26b6', letter: 'Ma', fill: '#cccccc' },
            jup: { symbol: '\u2643', letter: 'J', fill: '#ffaa33' },
            sat: { symbol: '\u2644', letter: 'Sa', fill: '#ffdd66' },
            ura: { symbol: '\u2645', letter: 'U', fill: '#66ccff' },
            nep: { symbol: '\u2646', letter: 'N', fill: '#6666ff' },
            plu: { symbol: '\u2647', letter: 'P', fill: '#aaaaaa' },
            eri: { symbol: '\u26aa', letter: 'E', fill: '#eeeeee' }
        },
        names: false,
        nameStyle: {
            fill: '#cccccc',
            font: "17px 'Lucida Sans Unicode', 'DejaVu Sans'",
            align: 'right',
            baseline: 'top'
        },
        namesType: 'desig'
    },
    background: {
        // Background style
        fill: '#000000', // Area fill
        opacity: 1,
        stroke: '#000000', // Outline
        width: 0
    },
    horizon: {
        //Show horizon marker, if location is set and map projection is all-sky
        show: false,
        stroke: '#cccccc', // Line
        width: 1.0,
        fill: '#000000', // Area below horizon
        opacity: 0.5
    }
};

const rootConfig = {
    selectedDate: new Date(),
    defaultStyle: STAR_MAP_STYLES[0],
    celestialConfig: celestialConfig
};

export const addStarMapDependencies = async () => {
    const scripts = document.getElementsByTagName('script');
    for (const script of scripts) {
        const { src } = script;
        if (src.includes(resources.d3Cdn) || src.includes(resources.d3CelestialCdn)) return;
    }

    await loadScript(resources.d3Cdn);
    const dependencies = [
        // Celestial dependencies
        loadScript(resources.d3GeoProjectionCdn),
        loadScript(resources.d3CelestialCdn),
        loadStyle(resources.d3CelestialCss)
    ];

    return Promise.all(dependencies);
};

const createCelestialContainer = () => {
    const celestialContainer = document.createElement('div');
    celestialContainer.style.position = 'absolute';
    celestialContainer.style.right = '2000px';
    const celestialFormContainer = document.createElement('div');
    celestialContainer.id = 'celestial-map';
    celestialFormContainer.id = 'celestial-form';
    document.querySelector('.canvas-container').appendChild(celestialContainer);
    document.querySelector('.panel-body')?.appendChild(celestialFormContainer);

    Celestial.display(celestialConfig);
    //We implemented a timeout because the Celestial.display isn't a promise by itself but it takes some time to load.
    return new Promise((resolve, reject) => {
        setTimeout(resolve, 400);
    });
};
export const showCelestialContainer = async (config = null, mutex = null) => {
    const celestialContainer = document.querySelector('#celestial-map');
    if (!celestialContainer) {
        const tasks = [createCelestialContainer(), waitForLocation([0, 0], 500)];
        await Promise.all(tasks);
    }
    if (config) {
        const image = await updatedDisplayStarMap(updatedConfig(config), mutex);
        return image;
    }

    //We don't need to literally show the element, the dataUrl will still retrieve the data regardless if its displayed: none o block
    hideCelestialContainer();
};

const waitForLocation = ([lat, long], delay = 0) => {
    Celestial.location([lat, long]);
    return new Promise((resolve, reject) => {
        setTimeout(resolve, delay);
    });
};

export const attachGeocoderToContainer = (geocoderContainer) => {
    geocoderContainer.style = {};
    document.body.appendChild(geocoderContainer);
    geocoderContainer.setAttribute('class', '');
    geocoderContainer.querySelector('.mapboxgl-ctrl-geocoder.mapboxgl-ctrl input').style.color = 'black';
    document.getElementById('star-map-geocoder').appendChild(geocoderContainer);
};

export const updatedDisplayStarMap = async (config, mutex = null) => {
    let svg = '';
    if (mutex != null) {
        await mutex.acquire();
        try {
            svg = await updateAndReturnSnapshot(config);
        } finally {
            mutex.release();
        }
    } else {
        svg = await updateAndReturnSnapshot(config);
    }
    return svg;
};

export const updateAndReturnSnapshot = async (config) => {
    const celestialForm = document.querySelector('#celestial-form');
    if (!celestialForm) return;
    if (!config) return this.getStarMapSVGSnapshot();

    const { celestialConfig, selectedDate, selectedLocation } = config;
    Celestial.apply(celestialConfig);
    const { geopos } = celestialConfig;
    const currentCordinates = Celestial.location();
    if (
        geopos &&
        geopos[0] != 0 &&
        geopos[1] != 0 &&
        geopos[0] != currentCordinates[0] &&
        geopos[1] != currentCordinates[1]
    ) {
        await waitForLocation(geopos, 400);
    }
    if (selectedDate) {
        const celestialDate = Celestial.date();
        celestialDate.setHours(0, 0, 0, 0);
        const tmpDate = new Date(selectedDate);
        tmpDate.setHours(0, 0, 0, 0);

        if (celestialDate.getTime() !== tmpDate.getTime()) {
            Celestial.date(new Date(selectedDate));
        }
    }
    const snapshot = await getStarMapSVGSnapshot();
    return snapshot;
};

export const getStarMapSVGSnapshot = async () => {
    if (!Celestial) return;
    var svgExported;
    Celestial.exportSVG((svg) => {
        svgExported = svg;
    });
    await waitForCurrentSVGExport();
    return svgExported;
};

const waitForCurrentSVGExport = async () => {
    let celestialContainer = document.getElementById('d3-celestial-svg');
    if (celestialContainer != null) {
        await delay(200);
        await waitForCurrentSVGExport();
    }
};

const delay = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
};

export const hideCelestialContainer = () => {
    const celestialContainer = document.querySelector('#celestial-map');
    const celestialForm = document.querySelector('#celestial-form #loc');
    if (!celestialContainer) return;
    if (!celestialForm) return;
    if (celestialContainer.style.display == 'none') return;
    if (celestialForm.style.display == 'none') return;
    celestialContainer.style.display = 'none';
    celestialForm.style.display = 'none';
};

export const updatedConfig = (newConfig) => {
    if (!newConfig) return rootConfig;
    let config = {
        ...rootConfig,
        ...newConfig
    };

    config = {
        ...config,
        celestialConfig: {
            ...config.celestialConfig,
            geopos: newConfig.selectedLocation,
            stars: {
                ...config.celestialConfig.stars,
                style: { ...config.celestialConfig.stars.style, fill: newConfig.defaultStyle.elements } // Default style for stars
            },
            constellations: {
                ...config.celestialConfig.constellations,
                lines: newConfig.shopperConfigEnabled || newConfig.showConstellations,
                lineStyle: {
                    ...config.celestialConfig.constellations.lineStyle,
                    stroke: newConfig.defaultStyle.elements
                },
                boundStyle: {
                    ...config.celestialConfig.constellations.boundStyle,
                    stroke: newConfig.defaultStyle.elements
                }
            },
            mw: {
                ...config.celestialConfig.mw,
                show: newConfig.shopperConfigEnabled || newConfig.showMilkyWay,
                style: {
                    ...config.celestialConfig.mw.style,
                    fill: newConfig.defaultStyle.elements
                }
            },
            lines: {
                ...config.celestialConfig.lines,
                graticule: {
                    ...config.celestialConfig.lines.graticule,
                    show: newConfig.shopperConfigEnabled || newConfig.showGridLines,
                    stroke: newConfig.defaultStyle.elements
                }
            },
            background: {
                ...config.celestialConfig.background,
                fill: newConfig.defaultStyle.background,
                stroke: newConfig.defaultStyle.background,
                opacity: newConfig.defaultStyle.backgroundOpacity
            }
        }
    };

    /*When the star map was an image, if the background was white and the opacity was 0, the style would be transparent.
    Now that the map is an SVG this doesn't work and we need to override some properties.
    This was done by overwriting the properties to avoid having to modify all the properties of old star maps that were images in the DB.*/
    if (newConfig.defaultStyle.background === '#FFFFFF' && newConfig.defaultStyle.backgroundOpacity === 0) {
        config.celestialConfig.background.fill = 'none';
        config.celestialConfig.background.stroke = '#FFFFFF';
        config.celestialConfig.background.width = 1;
    }
    return config;
};
